import { useMutation, useQuery } from '@tanstack/react-query'

import type { UseQueryResult, UseMutationResult } from '@tanstack/react-query'
import type { IAppBuild, IUseBuildsListQueryParams } from '~/types/build'

import { getBuilds, updateBuild } from '~/api/builds'

////////// KEYS //////////

export const keys = {
  all: ['builds'] as const,
  list: (params?: IUseBuildsListQueryParams) => [...keys.all, 'list', params] as const,
}

////////// QUERIES //////////

export const useBuildsListQuery = (params?: IUseBuildsListQueryParams): UseQueryResult<IAppBuild[], unknown> => {
  return useQuery({
    queryFn: () => getBuilds(params),
    queryKey: keys.list(params),
  })
}

//////// MUTATIONS //////////

export const useUpdateBuildMutation = (): UseMutationResult<IAppBuild, unknown, IAppBuild, unknown> => {
  return useMutation({ mutationFn: updateBuild })
}
